const STORAGE_PREFIX = 'mytapstart_mock_';

const getMockData = (key) => {
    const data = localStorage.getItem(STORAGE_PREFIX + key);
    return data ? JSON.parse(data) : null;
};

const saveMockData = (key, data) => {
    localStorage.setItem(STORAGE_PREFIX + key, JSON.stringify(data));
};

const createMockEntity = (name, initialData = []) => {
    if (!getMockData(name)) {
        saveMockData(name, initialData);
    }

    return {
        list: async (order) => {
            let data = getMockData(name) || [];
            if (order && order.startsWith('-')) {
                const field = order.substring(1);
                data = [...data].sort((a, b) => (b[field] > a[field] ? 1 : -1));
            }
            return data;
        },
        filter: async (filters) => {
            const data = getMockData(name) || [];
            return data.filter(item => {
                return Object.entries(filters).every(([key, value]) => item[key] === value);
            });
        },
        create: async (payload) => {
            const data = getMockData(name) || [];
            const newItem = { ...payload, id: Math.random().toString(36).substr(2, 9), created_date: new Date().toISOString() };
            data.push(newItem);
            saveMockData(name, data);
            return newItem;
        },
        bulkCreate: async (payloads) => {
            const data = getMockData(name) || [];
            const newItems = payloads.map(p => ({ ...p, id: Math.random().toString(36).substr(2, 9), created_date: new Date().toISOString() }));
            saveMockData(name, [...data, ...newItems]);
            return newItems;
        },
        update: async (id, payload) => {
            const data = getMockData(name) || [];
            const index = data.findIndex(item => item.id === id);
            if (index === -1) throw new Error(`${name} not found`);
            const updatedItem = { ...data[index], ...payload };
            data[index] = updatedItem;
            saveMockData(name, data);
            return updatedItem;
        },
        delete: async (id) => {
            const data = getMockData(name) || [];
            const filtered = data.filter(item => item.id !== id);
            saveMockData(name, filtered);
            return { success: true };
        }
    };
};

export const mockClient = {
    auth: {
        me: async () => {
            const user = localStorage.getItem(STORAGE_PREFIX + 'user');
            if (!user) throw { type: 'auth_required', message: 'Authentication required' };
            return JSON.parse(user);
        },
        login: async (email, password) => {
            // Check specifically for the requested credentials
            if (email === 'mytapstar' && password === 'Developermytapstar8111#') {
                const user = {
                    id: 'user_mytapstar',
                    email: 'mytapstar',
                    full_name: 'MyTapStar Admin',
                    role: 'ADMIN'
                };
                localStorage.setItem(STORAGE_PREFIX + 'user', JSON.stringify(user));
                return { success: true, user };
            }
            throw new Error('Credenciales incorrectas');
        },
        logout: async () => {
            localStorage.removeItem(STORAGE_PREFIX + 'user');
        },
        redirectToLogin: () => {
            window.location.href = '/login';
        }
    },
    entities: {
        Organization: createMockEntity('organizations', [
            { id: 'org_1', name: "Mi Empresa Demo", billing_email: "demo@mytapstart.com", phone: "+34 912 345 678", country: "ES", plan: "PRO", status: "ACTIVE" }
        ]),
        Location: createMockEntity('locations', [
            { id: 'loc_1', organization_id: 'org_1', name: "Restaurante La Estrella", address: "Calle Gran Vía 28", city: "Madrid", category: "Restaurante", rating_average: 4.6, total_reviews: 234 },
            { id: 'loc_2', organization_id: 'org_1', name: "Hotel Boutique Barcelona", address: "Paseo de Gracia 45", city: "Barcelona", category: "Hotel", rating_average: 4.8, total_reviews: 156 }
        ]),
        Review: createMockEntity('reviews', [
            { id: 'rev_1', location_id: 'loc_1', author_name: "María García", rating: 5, text: "¡Experiencia increíble!", review_date: new Date().toISOString(), status: "PENDING", sentiment: "POSITIVE" }
        ]),
        BrandTone: createMockEntity('brand_tones', []),
        AutoReplyRule: createMockEntity('auto_reply_rules', []),
        Template: createMockEntity('templates', []),
        Device: createMockEntity('devices', []),
        GMBPost: createMockEntity('gmb_posts', []),
        LinkTree: createMockEntity('link_trees', []),
        Query: {
            execute: async () => []
        }
    },
    appLogs: {
        logUserInApp: async () => ({ success: true })
    },
    integrations: {
        Core: {
            InvokeLLM: async () => ({ text: "Esta es una respuesta simulada por IA." }),
            SendEmail: async () => ({ success: true }),
            SendSMS: async () => ({ success: true }),
            UploadFile: async ({ file }) => {
                if (file instanceof File || file instanceof Blob) {
                    return new Promise((resolve) => {
                        const reader = new FileReader();
                        reader.onload = () => resolve({ file_url: reader.result });
                        reader.readAsDataURL(file);
                    });
                }
                return { file_url: "https://qtrypzzcjebvfcihiynt.supabase.co/storage/v1/object/public/base44-prod/public/68eb664650f49f6157faa391/f6b3a1c91_Gemini_Generated_Image_horbt8horbt8horb.png" };
            },
            GenerateImage: async () => ({ url: "https://example.com/mock-image.png" }),
            ExtractDataFromUploadedFile: async () => ({ data: {} })
        }
    }
};
